<template>
    <div>
        <v-btn
            class="ma-1 action-btn text-subtitle-2"
            depressed
            color="primary"
            @click="respond"
        >
            <v-icon
                left
                class="action-icon"
            >
                reply
            </v-icon>
            Respond
        </v-btn>
        <v-btn
            v-if="online"
            class="ma-1 action-btn text-subtitle-2"
            depressed
            color="primary"
            @click="assign"
        >
            <v-icon
                left
                dark
                class="material-icons-outlined action-icon"
            >
                assignment_turned_in
            </v-icon>
            Assign
        </v-btn>
    </div>
</template>

<script>

export default {
    name: 'ControlButtons',
    computed: {
        online() {
            return !this.$store.getters.forceOffline;
        }
    },
    methods: {
        respond() {
            this.$emit('open-respond-dialog');
        },
        assign() {
            this.$emit('open-assign-dialog');
        },
    }
};
</script>